<template>
  <v-dialog
    v-model="confirmacion.estatus"
    max-width="420"
    persistent
  >
    <v-card>
      <v-card-text class="pt-4 pb-2 px-4">
        <v-img src="@/assets/seguro.jpeg" contain max-height="360"></v-img>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn
          dark
          tile
          small
          color="grey darken-3"
          class="px-4"
          @click="confirmacion.estatus = false"
        >
          Mejor reviso
          <v-icon small right>mdi-cancel</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          dark
          tile
          small
          color="green darken-1"
          class="px-4"
          @click="confirmar()"
        >
          Sí, muy seguro
          <v-icon small right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['confirmacion'],

  methods: {
    confirmar() {
      this.$emit('addCambio')
      this.confirmacion.estatus = false
    },
  },
}
</script>
